import headingTheme from './heading'

const tableTheme = {
    variants: {
        'j-simple': () => ({
            th: {
                ...headingTheme?.sizes?.chakra_title_small,
                backgroundColor: 'surfacePlus4',
                padding: '24px 16px',
                textAlign: 'left',
                color: 'onSurfaceVariant',
                textTransform: 'capitalize',
                "&:first-of-type": {
                    borderTopLeftRadius: '16px',
                },
                "&:last-of-type": {
                    borderTopRightRadius: '16px',
                }
            },
            td: {
                ...headingTheme?.sizes?.chakra_body_medium,
                backgroundColor: 'background',
                padding: '22px 16px',
                textAlign: 'left',
                color: 'onSurface',
            },
        })
    },
}

export default tableTheme